import { Link } from 'react-router-dom';
import './Navbar.css';
import { useAuth } from "../../Utils/Auth";
const NavLinks = ({isClicked, closeMenu}) =>{

    const auth = useAuth()
    const isAdmin = auth.isAdmin
    return(
        <>
            <nav className="NavLinks">
                <ul>
                    <li onClick={() => isClicked && closeMenu()}>
                        <a href="#Fairepart">Accueil</a>
                    </li>
                    <li onClick={() => isClicked && closeMenu()}>
                        <a href='#Sondage'>Sondage</a>
                    </li>
                    {/* <li onClick={() => isClicked && closeMenu()}>
                        <a href="/#about">About Us</a>
                    </li> */}
                    <li onClick={() => isClicked && closeMenu()}>
                        <a href='#Adresses'>Adresses</a>
                    </li>
                    <li onClick={() => isClicked && closeMenu()}>
                        { isAdmin && <Link to="/admin">Admin</Link> }
                    </li>
                </ul>
            </nav>
            
           
        </>
    )
}

export default NavLinks;